import { render, staticRenderFns } from "./EarlyPenalties.vue?vue&type=template&id=4d97cc22&"
import script from "./EarlyPenalties.vue?vue&type=script&lang=js&"
export * from "./EarlyPenalties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports